import { useEffect, useRef } from 'react'
import { generateUniqueKey } from '../../Utility'

/**
 * Restituisce un componente di checkbox personalizzato con etichetta e stato indeterminato opzionali.
 *
 * @param {boolean} checked - Lo stato di selezione iniziale del checkbox.
 * @param {boolean} indeterminate - Se la checkbox è in stato indeterminato.
 * @param {boolean} disabled - Se la checkbox è disabilitato.
 * @param {string} label - Il testo dell'etichetta associata al checkbox.
 * @param {string} ariaLabel - L'etichetta ARIA per scopi di accessibilità, predefinita su label.
 * @param {function} onChange - Funzione di callback attivata al cambio di stato del checkbox.
 *
 */
export function StarCheckbox({
  checked = false,
  indeterminate = false,
  disabled = false,
  label = '',
  ariaLabel = label,
  onChange
}) {
  const id = generateUniqueKey()
  const checkBoxRef = useRef()

  useEffect(() => {
    checkBoxRef.current.indeterminate = indeterminate
    checkBoxRef.current.checked = checked
  }, [indeterminate, checked])

  return (
    <div className="custom-control custom-checkbox d-flex justify-content-center">
      <input
        type="checkbox"
        className="custom-control-input cursor-pointer"
        aria-label={ariaLabel}
        id={id}
        disabled={disabled}
        defaultChecked={checked}
        onChange={onChange}
        ref={checkBoxRef}
      />

      <label className="custom-control-label star-checkbox" htmlFor={id}>
        {label}
      </label>
    </div>
  )
}
